(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 83305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_SmootherContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92868);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31555);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16573);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1020);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53597);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(37332);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(48137);
/* harmony import */ var react_share__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(66339);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36981);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30653);
/* harmony import */ var _components_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68019);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(68777);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(68312);
/* harmony import */ var _components_error_404__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38298);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


















var PostDetail = function PostDetail(_ref) {
  var _data$data, _data$data2, _getData$data;

  var data = _ref.data;
  var detailData = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function (state) {
    return state.newsReducer;
  });
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
  var getData = data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.data);
  var getImages = data && (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.images);
  var banner = getImages === null || getImages === void 0 ? void 0 : getImages.list.find(function (f) {
    return (f === null || f === void 0 ? void 0 : f.banner) === 'on';
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      shareUrl = _useState[0],
      setShareUrl = _useState[1];

  var shareButtonClickM = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var shareButtonContentM = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setShareUrl(window.location.href);
  }, [shareUrl]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _shareButtonClickM$cu;

    shareButtonClickM === null || shareButtonClickM === void 0 ? void 0 : (_shareButtonClickM$cu = shareButtonClickM.current) === null || _shareButtonClickM$cu === void 0 ? void 0 : _shareButtonClickM$cu.addEventListener('click', function () {
      var _shareButtonContentM$;

      (_shareButtonContentM$ = shareButtonContentM.current) === null || _shareButtonContentM$ === void 0 ? void 0 : _shareButtonContentM$.classList.toggle('open');
    });
    window.addEventListener('click', function (e) {
      var _shareButtonContentM$2;

      if (shareButtonContentM !== null && shareButtonContentM !== void 0 && (_shareButtonContentM$2 = shareButtonContentM.current) !== null && _shareButtonContentM$2 !== void 0 && _shareButtonContentM$2.classList.contains('open')) {
        if (!e.target.matches('.social-vertical, .social-vertical img')) {
          var _shareButtonContentM$3;

          shareButtonContentM === null || shareButtonContentM === void 0 ? void 0 : (_shareButtonContentM$3 = shareButtonContentM.current) === null || _shareButtonContentM$3 === void 0 ? void 0 : _shareButtonContentM$3.classList.remove('open');
        }
      }
    });
  }, [shareButtonContentM]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var contentRefs = document.querySelectorAll('.pin-it');

    if (contentRefs) {
      contentRefs.forEach(function (box) {
        gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_10__.ScrollTrigger.create({
          trigger: box,
          pin: true,
          start: 'top +200',
          end: 'bottom',
          pinSpacing: false
        });
      });
    }
  }, []);
  var smoother = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_components_SmootherContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);

  var killSmoother = function killSmoother() {
    if (smoother && smoother.revert) {
      smoother.revert();
    }
  };

  var currentUrlTag = router && router.asPath;
  var dateString = getData === null || getData === void 0 ? void 0 : getData.date;
  var date = new Date(dateString); // Array of month names

  var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; // Extracting day, month, and year from the date object

  var day = date.getDate();
  var monthIndex = date.getMonth();
  var year = date.getFullYear(); // Constructing the formatted date string

  var formattedDate = day + " " + months[monthIndex] + " " + year;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
    children: [getData ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
      title: "".concat(getData !== null && getData !== void 0 && getData.title ? (getData === null || getData === void 0 ? void 0 : getData.title) + ' | News | ' : '', "Shanta Securities Limited"),
      description: getData === null || getData === void 0 ? void 0 : getData.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrlTag,
      openGraph: {
        title: getData === null || getData === void 0 ? void 0 : getData.title,
        description: getData === null || getData === void 0 ? void 0 : getData.meta_description,
        images: [{
          url: banner === null || banner === void 0 ? void 0 : banner.full_path,
          width: 800,
          height: 600,
          alt: getData === null || getData === void 0 ? void 0 : getData.title
        }, {
          url: banner === null || banner === void 0 ? void 0 : banner.full_path,
          width: 800,
          height: 600,
          alt: getData === null || getData === void 0 ? void 0 : getData.title
        }]
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
      title: "404 - Shanta Securities Limited"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledComponent, {
      children: getData ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("section", {
        id: 'details',
        className: "case_study_detail pb-160",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              md: 3,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "social-vertical pin-it",
                  ref: shareButtonClickM,
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                    children: "Share:"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "clearfix"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "social-lists",
                    ref: shareButtonContentM,
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                      url: shareUrl,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                        size: 32,
                        round: true
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                      url: shareUrl,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        size: 32,
                        round: true
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                      url: shareUrl,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_share__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        size: 32,
                        round: true
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "video",
                  children: (getData === null || getData === void 0 ? void 0 : (_getData$data = getData.data) === null || _getData$data === void 0 ? void 0 : _getData$data.link) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "click",
                    onClick: function onClick() {
                      return handleShow(true);
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                      iconvideo: true,
                      newtablink: 'javascript:void(0)',
                      text: "Watch Video",
                      margin: "30px 0 0 0",
                      background: "white",
                      color: "#3C3C3B",
                      borderColor: '#3C3C3B',
                      icon: true,
                      border: '1px solid'
                    })
                  })
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              md: {
                span: 9
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "header",
                children: [getData !== null && getData !== void 0 && getData.title ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h1", {
                  className: 'split-up',
                  children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(getData === null || getData === void 0 ? void 0 : getData.title)
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("h1", {
                  children: "Offer on Domestic Flights"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                  children: getData !== null && getData !== void 0 && getData.chapter ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("span", {
                    children: [getData === null || getData === void 0 ? void 0 : getData.chapter, " Chapters"]
                  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("span", {
                    className: "",
                    children: ["Date: ", formattedDate]
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "case_study_image_wrapper",
                children: banner !== null && banner !== void 0 && banner.full_path ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Img__WEBPACK_IMPORTED_MODULE_7__/* .Img */ .E, {
                  src: banner === null || banner === void 0 ? void 0 : banner.full_path
                }) : null
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "blog_details",
                children: (getData === null || getData === void 0 ? void 0 : getData.body) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(getData === null || getData === void 0 ? void 0 : getData.body)
              })]
            })]
          })
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_error_404__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_20__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "slug__StyledComponent",
  componentId: "sc-d4vxiu-0"
})(["position:relative;.position_relative{position:relative;}iframe{margin-top:10px;width:100%;min-height:400px;@media (max-width:767px){height:190px;min-height:auto;}}a{color:", "}.case_study_detail{padding-top:150px;.header{margin-bottom:40px;p{font-size:12px;font-weight:500;line-height:16px;color:#3C3C3B;span{border-right:1px solid rgba(60,60,59,0.2);padding-right:20px;padding-left:20px;&.red{color:#d20f0f;}&:last-child{padding-right:20px;border-right:0;}&:first-child{padding-left:0;}}}h1{font-size:32px;font-weight:500;line-height:32px;color:#978C21;margin:0 0 10px;font-family:", ";}}.case_study_image_wrapper{position:relative;padding-top:50%;}.blog_details{padding-top:80px;.ratio{position:relative;padding-top:50%;iframe{position:absolute;inset:0px;object-fit:cover;min-height:unset;height:100%;width:100%;}}h6{font-size:20px;font-weight:500;line-height:24px;margin-bottom:5px;}h3{font-size:24px;font-weight:500;line-height:28px;color:#978C21;margin-bottom:20px;}p{margin-bottom:40px;&:last-child{margin-bottom:0;}}.flex{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between;align-items:flex-start;img{flex:0 0 calc(50% - 15px);display:block;max-width:calc(50% - 15px);@media (max-width:767px){flex:0 0 calc(50% - 7.5px);display:block;max-width:calc(50% - 7.5px);}}}ul{margin-bottom:20px;li{padding-left:15px;margin-bottom:10px;position:relative;&:after{position:absolute;left:0;top:9px;width:5px;height:5px;border-radius:50%;content:'';background:", ";}&:last-child{margin-bottom:0;}}}}}.social-vertical{p{margin-bottom:20px;}}.social-lists{display:flex;width:auto;align-items:flex-start;@media (max-width:767px){flex-direction:row;}svg{height:30px;width:30px;circle{fill:transparent;stroke:#978C21;}path{fill:#978C21;}&:hover{circle{stroke:#3C3C3B;}path{fill:#3C3C3B;}}}button{margin-right:20px;@media (max-width:767px){margin-bottom:0px;margin-left:0px;margin-right:10px;}&:last-child{margin-bottom:20px;}}}@media (max-width:992px){.case_study_detail{.row{flex-direction:column-reverse;.col-md-9,.col-md-3{width:100%;max-width:100%;}}.social-vertical{margin-top:60px;}}}@media (max-width:767px){table{display:block;overflow-x:scroll;overflow-y:scroll;}.case_study_detail{padding-top:150px;}.case_study_detail .case_study_image_wrapper{}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_21__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_21__/* .title */ .TN, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_21__/* .hover */ .Mr);
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (PostDetail);

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(83305);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [653,7724,8298,7311,9774,2888,179], function() { return __webpack_exec__(3725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);